/*
PROV: COHINT001.BF.PUDKGT2ZMZ
REQ: SYS-ARCH-15
WHY: Shared package module.
*/

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, type UseFormProps } from "react-hook-form";
import type { z } from "zod";

// Use the first parameter type of zodResolver directly so this stays
// compatible regardless of Zod internal type changes across versions.
type ZodSchema<T> = Parameters<typeof zodResolver>[0] & z.ZodType<T>;

export function useZodForm<T extends Record<string, any>>(
  schema: ZodSchema<T>,
  options: UseFormProps<T> = {},
) {
  return useForm<T>({
    ...options,
    resolver: zodResolver(schema) as any,
  });
}

